
import { useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../baseurl"; 
import { useToast } from "../admincomponents/AdminToast";
export default function AdminLogin() {
  const navigate = useNavigate();
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    try {
      const { data } = await axios.post(`${BASE_URL}/admin/login`, {
        email: formData.email,
        password: formData.password,
      });

      localStorage.setItem("adminToken", data.token);

      toast({
        variant: "success",
        title: "Signed in",
        description: "Redirecting you to the dashboard...",
      });

      navigate("/admin");
    } catch (error) {
      const message =
        error.response?.data?.message ||
        "Something went wrong during login.";

      toast({
        variant: "error",
        title: "Sign in failed",
        description: message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <div className="w-full max-w-[420px] bg-white border border-gray-200 rounded-lg shadow-sm p-10">
        <div className="flex flex-col items-center mb-8">
          <div className="w-14 h-14 rounded-full bg-teal-500 flex items-center justify-center mb-4">
            <svg
              width="26"
              height="26"
              viewBox="0 0 24 24"
              fill="none"
              className="text-white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 12a4 4 0 100-8 4 4 0 000 8zM4 20a8 8 0 0116 0"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <h1 className="text-gray-800 font-semibold text-[24px]">Admin Login</h1>
          <p className="text-gray-500 text-[14px] mt-1">
            Sign in to manage Futura Bio Labs
          </p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-6">
          <div>
            <label className="block text-gray-600 text-sm font-medium mb-2">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="you@futuraresearch.com"
              className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-3 text-gray-800 text-sm focus:outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-500"
            />
          </div>

          <div>
            <label className="block text-gray-600 text-sm font-medium mb-2">
              Password
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="••••••••"
              className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-3 text-gray-800 text-sm focus:outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-500"
            />
          </div>

          <div className="flex items-center justify-between text-sm">
            <label className="flex items-center gap-2 text-gray-500">
              <input type="checkbox" className="accent-teal-500" />
              Remember me
            </label>
            <NavLink to="/admin/forgot-password" className="text-teal-600 hover:text-teal-700">
  Forgot password?
</NavLink>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-teal-500 hover:bg-teal-600 disabled:bg-teal-300 disabled:cursor-not-allowed text-white font-semibold text-sm rounded-md py-3 transition-colors"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <p className="text-center text-gray-500 text-sm mt-6">
          Don't have an account?{" "}
          <NavLink to="/admin/register" className="text-teal-600 hover:text-teal-700 font-medium">
            Create one
          </NavLink>
        </p>
      </div>
    </div>
  );
}